<template>

			<div class="content">
		        <div class="container-fluid">
		        	<div class="row">
			            <div class="col-md-12">
			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">Tambah Pemasukkan</h4>
							</div>
			                <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Keterangan</label>
                                                <input type="text" class="form-control" placeholder="Keterangan..." v-model="data.nama">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Jumlah (Pastikan Tarif paket tidak pakai titik/koma. Mis : 50000)</label>
                                                <input type="number" class="form-control" placeholder="Jumlah..." v-model="data.tarif" min="0">
                                            </div>
                                        </div>
                                    </div>
                                </div>
			                    <div class="row">
			                      <div class="col-md-12">
			                        <div class="form-group">
                                        <button class="btn btn-primary" @click="form.simpan()">Simpan</button>
			                        </div>
			                      </div>
			                    </div>
			                </div>
			              </div>
			            </div>
		        	</div>
		    	</div>
		    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

var numeral = require("numeral");

Vue.use(moment)

export default {
	components: { 
		moment,
	}, 
    setup() {
        const data = reactive({
            loading: true,
            nama: '',
            tarif: ''
        })

        const form = {
            simpan() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    bulan: sessionStorage.getItem('bulanIdBase'),
                    tahun: sessionStorage.getItem('tahunBase'),
                    type: "masuk",
                    keterangan: data.nama,
                    jumlah: data.tarif.replace(/[^0-9]/g, '')
                };
            
                var apiUrl = inter.PembukuanTambah();
                myGlobal.call(datax,apiUrl).then(x => {
                    if (x.status == true) {

                        location.href="#/pembukuan/pemasukkan"
                    
                    } else {
                        
                    }
                })
            }
        }
        return {
            data,
            myGlobal,
            form
        }
    },
    /*
  	data() {
		return {
			title: "Detail Servis",
			nama: '', 
			tarif: '',
		}
	},
	methods: {
        Simpan() {
			if (this.nama == "") {
				alert("Nama tidak boleh kosong");
				return false;
			}
			if (this.tarif == "") {
				alert("Tarif tidak boleh kosong");
				return false;
			}

			var data = new FormData();
            data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
            data.append('keterangan', this.nama);
            data.append('jumlah', this.tarif.replace(/[^0-9]/g, ''));
            data.append('type', 'masuk');
            data.append('bulan', this.nama);
            data.append('tahun', this.nama);
			
            var apiUrl = inter.PembukuanTambah(); 
            
			this.PostData(data,apiUrl).then(x => {
				this.loger(x);
				if (x.status) {
                    location.href="#/pembukuan/pemasukkan"
				} else {
				    alert(x.pesan);
				}
			})
        }
	},
    */
	mounted() {

	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pembukuan/pemasukkan-tambah.vue